import { render, staticRenderFns } from "./crm-laboratory-update.vue?vue&type=template&id=0f72b63d&"
import script from "./crm-laboratory-update.vue?vue&type=script&lang=js&"
export * from "./crm-laboratory-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports